import React from 'react';
import { Button, Divider } from '@scale/scaleui';
import { Flex } from '@scale/scaleui-radix';
import ChatBulkAuditTranslateButton from './ChatBulkAuditTranslateButton';
import { ChatBulkAuditEditSummaryView } from './ChatBulkAuditEditSummaryView';
import { ITranslateTaskResponse } from '@scale/shared/types/lookup';

interface ChatRendererHeaderProps {
  readOnly: boolean;
  edited?: boolean;
  editedStepList?: string[];
  showTranslatedResponses: boolean;
  isLoadingTranslatingResponses: boolean;
  responses: any;
  translatedTask?: ITranslateTaskResponse;
  onRevertEdits: () => void;
  onTranslationToggle: () => void;
}

export const ChatRendererHeader: React.FC<ChatRendererHeaderProps> = ({
  readOnly,
  edited,
  editedStepList,
  showTranslatedResponses,
  isLoadingTranslatingResponses,
  responses,
  translatedTask,
  onRevertEdits,
  onTranslationToggle,
}) => {
  return (
    <div className="flex-none sticky top-0 z-10 w-full py-4">
      {readOnly ? (
        <div className="flex justify-start ml-4">
          <Flex gap="2" direction="row" justify="start" align="center">
            <ChatBulkAuditTranslateButton
              showTranslatedResponses={showTranslatedResponses}
              isLoadingTranslatingResponses={isLoadingTranslatingResponses}
              responses={responses}
              onToggle={onTranslationToggle}
              translatedTask={translatedTask}
            />
            {editedStepList && editedStepList.length > 0 && (
              <ChatBulkAuditEditSummaryView editedStepList={editedStepList} />
            )}
          </Flex>
        </div>
      ) : (
        <div className="flex justify-start">
          {edited && (
            <Button className="mx-4" variant="neutral" onClick={onRevertEdits}>
              Revert Edits
            </Button>
          )}
          <ChatBulkAuditEditSummaryView editedStepList={editedStepList} />
        </div>
      )}
      <Divider className="mt-4" />
    </div>
  );
};
